import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaChevronLeft, FaBoxOpen, FaTags, FaCapsules, FaStickyNote } from "react-icons/fa";

const ResepDetail = () => {
  const { name, outlet } = useParams();
  const [resepDetail, setResepDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const token = localStorage.getItem("token");

  // Gabungkan kembali menjadi format API (name-outlet)
  const formattedNameOutlet = `${decodeURIComponent(name)}-${decodeURIComponent(outlet)}`;

  useEffect(() => {
    const fetchResepDetail = async () => {
      try {
        if (!name || !outlet) {
          throw new Error("Parameter URL tidak valid");
        }

        console.log("Fetching data for:", formattedNameOutlet);

        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack/${formattedNameOutlet}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Response status:", response.status);

        if (response.status === 404) {
          setError(true);
          setResepDetail(null);
          return;
        }

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response data:", data);

        if (!data.success || !data.data) {
          setError(true);
          return;
        }

        setResepDetail(data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchResepDetail();
  }, [formattedNameOutlet, token]);

  if (loading) {
    return <div className="p-5 text-center">Loading...</div>;
  }

  if (error || !resepDetail) {
    return (
      <div className="p-5 text-center text-red-500">
        ❌ Data tidak ditemukan. <br />
        <button onClick={() => window.location.reload()} className="mt-3 px-4 py-2 bg-blue-500 text-white rounded">
          Coba Lagi
        </button>
      </div>
    );
  }

  return (
    <div className="p-5 bg-gray-50 min-h-screen">
  <div className="flex items-center space-x-2 text-gray-600 mb-4">
    <FaChevronLeft className="text-lg" />
    <span className="text-sm">
      Obat / Obat Paket / Detail of {resepDetail.name}
    </span>
  </div>

  <div className="bg-white p-6 rounded-2xl shadow-md ring-1 ring-gray-200">
    <div className="flex items-center mb-4 text-gray-800 space-x-2">
      <FaBoxOpen className="text-xl text-indigo-500" />
      <h3 className="text-2xl font-bold">
        {resepDetail.name} | {outlet.replace(/_/g, " ")}
      </h3>
    </div>

    <div className="flex items-center space-x-6 mb-6">
      <div className="w-40 h-40 bg-gray-100 flex items-center justify-center rounded-xl border border-dashed border-gray-300">
        <span className="text-gray-400">No Image</span>
      </div>
      <div className="space-y-2">
        <div className="flex items-center space-x-2 text-green-600">
          <FaTags className="text-lg" />
          <p className="text-lg font-semibold">Harga Jual: Rp {resepDetail.harga_jual?.toLocaleString()}</p>
        </div>
        <div className="flex items-center space-x-2 text-green-600">
          <FaTags className="text-lg" />
          <p className="text-lg font-semibold">Harga Beli: Rp {resepDetail.harga_beli?.toLocaleString()}</p>
        </div>
      </div>
    </div>

    <div className="mb-6">
      <div className="flex items-center space-x-2 mb-2 text-gray-700">
        <FaCapsules className="text-lg text-blue-500" />
        <h4 className="text-lg font-semibold">List Obat</h4>
      </div>
      <ul className="space-y-1 text-gray-600">
        {resepDetail.items?.map((obat, index) => (
          <li
            key={index}
            className="flex justify-between bg-gray-50 px-3 py-2 rounded-md hover:bg-gray-100 transition"
          >
            <span>{obat.name}</span>
            <span className="font-medium">Qty: {obat.qty}</span>
          </li>
        ))}
      </ul>
    </div>

    <div>
      <div className="flex items-center space-x-2 mb-2 text-gray-700">
        <FaStickyNote className="text-lg text-yellow-500" />
        <h4 className="text-lg font-semibold">Deskripsi</h4>
      </div>
      <p className="text-gray-600 leading-relaxed bg-gray-50 p-3 rounded-md ring-1 ring-gray-100">
        {resepDetail.deskripsi || "Tidak ada deskripsi."}
      </p>
    </div>
  </div>
</div>
  );
};

export default ResepDetail;
